import { Button, PolarityNumber, Text, TextSize, Weight } from 'components'

import styled from 'styled-components'

export const Wrapper = styled.div``

export const WrapperInterval = styled.div`
  display: flex;
  gap: 20px;
  padding: 0px;
  margin-left: 5px;
`

export const ChartHeater = styled.div<{ isPortfolio: boolean; plateFormate: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  position: relative;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

export const HeadWrapper = styled.div<{ isPortfolio?: boolean; withButton?: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 30px;
`
export const HeaderStatistic = styled.div<{ fullWidth?: boolean }>``

export const CustomChangeWrapper = styled.div`
  display: flex;
  gap: 3px;
  align-items: center;
  min-width: 138px;
  ${({ theme }) => theme.mediaWidth.Desktop`
      gap: 5px;
      min-width: 150px;
  `}
`

export const TimeIntervals = styled(Text)<{ active?: boolean; isPortfolio?: boolean }>`
  margin: 0px;
  transition: 0.5s;
  cursor: pointer;
  font-weight: ${(props) => (props.active ? 800 : 300)};
  color: ${({ theme }) => theme.seashellWhiteToCoreGrey};
  font-size: ${TextSize.small};
  &:hover {
    font-weight: 500;
    transition: 0.5s all;
  }
`

export const CustomText = styled(Text)`
  color: ${({ theme }) => theme.whiteToCoreGrey};
  margin: 0;
  margin-bottom: 5px;
  display: flex;
  min-width: fit-content;
  min-width: 90px;
`

export const CustomTextHeader = styled(Text)`
  color: ${({ theme }) => theme.whiteToCoreGrey};
  margin: 0;
  margin-bottom: 5px;
  display: flex;
  min-width: 90px;
  font-size: ${TextSize.small};
  font-weight: ${Weight.Medium};
`

export const StyledDetailsText = styled(Text)`
  font-weight: ${Weight.SemiBold};
  font-size: ${TextSize.p};
`

export const ButtonBuySell = styled(Button)`
  display: flex;
  width: 150px;
  height: 40px;
  padding: 0px 20px;
`

export const StyledHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
`

export const ChartFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`

export const MobileWrapper = styled.div`
  height: 500px;
  margin: 20px 0 0 0;
  box-shadow: 0px 2px 20px rgb(0 0 0 / 15%);
  border-radius: 20px;
  padding: 30px 30px 20px 30px;
  div {
    canvas {
      ${({ theme }) => theme.mediaWidth.Tablet`
        height: 430px;
      `}
      ${({ theme }) => theme.mediaWidth.Mobile`
        height: 350px;
      `}
    }
  }
  ${({ theme }) => theme.mediaWidth.Mobile`
      height: 400px;
      margin: 20px 20px 0 20px;
  `}
`

export const PolarityNumberStyled = styled(PolarityNumber)`
  font-weight: ${Weight.Bold};
`

export const TourWrapper = styled.div`
  margin-bottom: 30px;
`
